import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchBoxProps {
  defaultValue?: string;
  variant?: "compact" | "large";
  placeholder?: string;
}

export default function SearchBox({
  defaultValue = "",
  variant = "compact",
  placeholder = "输入人物名或事件名称，如「沈嘉木」",
}: SearchBoxProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = value.trim();
    navigate(keyword ? `/keywords?q=${encodeURIComponent(keyword)}` : "/keywords");
  };

  const isLarge = variant === "large";

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className={
        isLarge
          ? "flex w-full flex-col gap-3 sm:flex-row sm:items-center sm:gap-2 sm:rounded-full sm:border sm:border-background-300 sm:bg-background-50 sm:p-2 sm:shadow-none"
          : "flex w-full items-center gap-2"
      }
    >
      <label className="sr-only" htmlFor={`site-search-${variant}`}>
        站内关键词搜索
      </label>
      <div className={isLarge ? "flex flex-1 items-center gap-2 px-4 sm:px-3" : "flex flex-1 items-center gap-2"}>
        <span className={`flex items-center justify-center text-foreground-400 ${isLarge ? "h-5 w-5" : "h-4 w-4"}`}>
          <i className={`ri-search-line ${isLarge ? "text-lg" : "text-base"}`} />
        </span>
        <input
          id={`site-search-${variant}`}
          type="search"
          name="q"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          placeholder={placeholder}
          className={
            isLarge
              ? "h-12 w-full bg-transparent text-base text-foreground-950 placeholder:text-foreground-400 focus:outline-none"
              : "h-9 w-full bg-transparent text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none"
          }
        />
      </div>
      <button
        type="submit"
        className={
          isLarge
            ? "inline-flex h-12 w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-400 sm:w-auto"
            : "inline-flex h-9 items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-400"
        }
      >
        <i className="ri-search-eye-line text-base" />
        搜一下
      </button>
    </form>
  );
}